// import icons
import { FaYoutube, FaInstagram, FaGithub } from 'react-icons/fa';
import { BsChatDotsFill } from 'react-icons/bs';

// import images
import AboutImg from '../src/assets/img/about2.png';
import Feature1Img from '../src/assets/img/features/fitur1.png';
import Feature2Img from '../src/assets/img/features/fitur2.png';
import Feature3Img from '../src/assets/img/features/fitur3.png';
import Feature4Img from '../src/assets/img/features/fitur4.png';
import Avatar1Img from '../src/assets/img/testimonials/avatar1.png';
import Avatar2Img from '../src/assets/img/testimonials/avatar2.png';
import Avatar3Img from '../src/assets/img/testimonials/avatar3.png';
import LogoV2 from '../src/assets/img/logo2.png';
import HeroImage from '../src/assets/img/hero.png';
import Feature1BgImg from '../src/assets/img/features/feature1_bg.png';
import Feature2BgImg from '../src/assets/img/features/feature2_bg.png';
import Feature3BgImg from '../src/assets/img/features/feature3_bg.png';
import Feature4BgImg from '../src/assets/img/features/feature4_bg.png';
import Nabiimg from "../src/assets/img/features/kisahnabi.png"
import Doaimg from "../src/assets/img/features/doaabout.png"
import Asmaulimg from "../src/assets/img/features/asmaul.png"
import Videoimg from "../src/assets/img/hero1.png"


export const navigationData = [
  {
    name: 'Home',
    href: '#hero',
  },
  {
    name: 'About',
    href: '#about',
  },
  {
    name: 'Fitur',
    href: '#fitur',
  },
  {
    name: 'Login',
    href: '#',
  },
];

export const heroData = {
  title: `Inspire Kids To Love Islam.`,
  subtitle:
    'Platform pembelajaran online bagi anak-anak untuk belajar tentang Islam & jalan lurus menuju Jannah.',
  btnText: 'Learn more',
  image: HeroImage,
};

export const aboutData = {
  image: AboutImg,
  title: 'We are a high-level data storage bank',
  subtitle:
    'The place to store various data that you can access at any time through the internet  and where you can carry it. This very flexible storage area has a high level of security. To enter into your own data you must enter the password that you created when you registered in this Data Warehouse.',
};

export const nabiData = {
  image: Nabiimg,
};

export const doaData = {
  image: Doaimg,
};

export const asmaulData = {
  image: Asmaulimg,
};

export const videoData = {
  image: Videoimg,
};

export const featuresData = {
  title: 'Features',
  subtitle:
    'Some of the features and advantages that we provide for those of you who store data in this Data Warehouse.',
  image1: Feature1Img,
  bgImage1: Feature1BgImg,
      
    
  image2: Feature2Img,
  bgImage2: Feature2BgImg,
      
   
  image3: Feature3Img,
  bgImage3: Feature3BgImg,
      
    
  image4: Feature4Img,
  bgImage4: Feature4BgImg,

};

export const testimonialsData = [
  {
    image: Avatar1Img,
    name: 'John Fang',
    web: 'wordfaang.com',
    message:
      'Suspendisse ultrices at diam lectus nullam. Nisl, sagittis viverra enim erat tortor ultricies massa turpis. Arcu pulvinar aenean nam laoreet nulla.',
    delay: '300',
  },
  {
    image: Avatar2Img,
    name: 'Jane Doe',
    web: 'janedoee.com',
    message:
      'Suspendisse ultrices at diam lectus nullam. Nisl, sagittis viverra enim erat tortor ultricies massa turpis. Arcu pulvinar aenean nam laoreet nulla.',
    delay: '600',
  },
  {
    image: Avatar3Img,
    name: 'Jim Ferry',
    web: 'jimjimf.com',
    message:
      'Suspendisse ultrices at diam lectus nullam. Nisl, sagittis viverra enim erat tortor ultricies massa turpis. Arcu pulvinar aenean nam laoreet nulla.',
    delay: '900',
  },
];

export const ctaData = {
  title: 'Try for free!',
  subtitle: 'Get limited 1 week free try our features!',
  btnText1: 'Learn more',
  btnText2: 'Daftar Sekarang',
};

export const footerData = {
  logo: LogoV2,
  address: 'Warehouse Society, 234 Bahagia Ave Street PRBW 29281',
  email: 'info@warehouse.project',
  phone: '1-232-3434 (Main)',
  list1: [
    {
      name: 'Profile',
      href: '#',
    },
    {
      name: 'Features',
      href: '#',
    },
    {
      name: 'Careers',
      href: '#',
    },
    {
      name: 'DW News',
      href: '#',
    },
  ],
  list2: [
    {
      name: 'Support',
      href: '#',
    },
    {
      name: 'Sign Up',
      href: '#',
    },
    {
      name: 'Guide',
      href: '#',
    },
    {
      name: 'Reports',
      href: '#',
    },
    {
      name: 'Q & A',
      href: '#',
    },
  ],
  socialList: [
    {
      icon: <FaYoutube />,
      href: '#',
    },
    {
      icon: <FaInstagram />,
      href: '#',
    },
    {
      icon: <FaGithub />,
      href: '#',
    },
  ],
};

export const copyrightData = {
  text: '© Datawarehouse™, 2020. All rights reserved. Company Registration Number: 21479524.',
  icon: <BsChatDotsFill />,
};
